<template>
  <Dialog :commonDialog="statusDialog" :dialog-width="650">
    <template v-slot:title>
      <div class="d-flex">Confirmed</div>
    </template>

    <template v-slot:body>
      <v-form ref="statusForm" v-model="formValid" lazy-validation>
        <v-row class="delete-dialog">
          <v-col md="12" class="py-0 my-auto py-2">
            <div class="d-form-grp">
              <label class="font-size-16 font-weight-500">
                Remarks
              </label>
              <TextAreaField
                auto-grow
                dense
                filled
                color="cyan"
                :rules="[]"
                v-model.trim="formData.remark"
                placeholder="Enter the Remarks"
                solo
                flat
                row-height="25"
                counter="200"
              />
            </div>

            <!-- Attachment -->
            <div class="mt-4">
              <div class="d-flex pt-1">
                <label class="font-size-16 font-weight-500">Attachment</label>
              </div>
              <FileUpload
                v-model="formData.attachments"
                :maxLimit="maxLimit"
              ></FileUpload>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </template>

    <template v-slot:action>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button white--text"
        :color="status === 'approved' ? 'green' : 'red'"
        :loading="pageLoading"
        :disabled="pageLoading || !formValid"
        @click="submitStatus"
        style="min-width: 78px !important"
      >
        <template v-if="status === 'approved'">Approve</template>
        <template v-else>Reject</template>
      </v-btn>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button"
        :disabled="pageLoading"
        @click="closeDialog"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import FileUpload from "@/view/components/app-component/FileInput.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { PUT } from "@/core/services/store/request.module";

export default {
  name: "Ot-Approved-Reject-Dialog",
  mixins: [ValidationMixin, CommonMixin],
  props: {
    statusDialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    status: {
      type: String,
      default: "approved",
    },
    otData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formValid: true,
      pageLoading: false,
      maxLimit: 5,
      formData: {
        remark: "",
        attachments: [],
      },
    };
  },
  watch: {
    statusDialog(val) {
      if (val) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData = {
        remark: "",
        attachments: [],
      };
      if (this.$refs.statusForm) {
        this.$refs.statusForm.resetValidation();
      }
    },
    closeDialog() {
      this.$emit("close");
      this.resetForm();
    },
    submitStatus() {
      const _this = this;
      if (_this.$refs.statusForm && !_this.$refs.statusForm.validate()) {
        return;
      }

      const id =
        _this.otData?.id || (_this.otData?.rows && _this.otData.rows[0]?.id);

      if (!id) {
        return;
      }

      _this.pageLoading = true;

      const payload = {
        status: _this.status,
        remarks: _this.formData.remark || null,
        attachments: _this.formData.attachments || [],
      };

      _this.$store
        .dispatch(PUT, {
          url: `engineer/ot-record/${id}`,
          data: payload,
        })
        .then(({ data }) => {
          _this.$emit("success", data);
          _this.closeDialog();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  components: {
    Dialog,
    TextAreaField,
    FileUpload,
  },
};
</script>
